<!-- //////////////// HEADER ///////////////////// -->

<div
  *ngIf="brandedPageMenuStyle"
  class="header-movie-menu-styles"
  [innerHTML]="brandedPageMenuStyle | safe: 'html'"
></div>

<div
  class="header-wrapper"
  [ngClass]="{ fixed: hasHeaderFixed() }"
  [style.position]="hasHeaderFixed() ? 'fixed' : 'absolute'"
  [class.noCollapsed]="isCollapse"
  [class.atTop]="atScrollTop"
>
  <div id="header" class="page-content">
    <ng-container *ngTemplateOutlet="logo"></ng-container>
    <div class="header-items" #headerItemsList>
      <ng-container *ngTemplateOutlet="logo; context: { class: 'nav-logo-inside' }"></ng-container>
      <ul class="header-links">
        <li
          *ngFor="let link of links"
          (click)="onHeaderLinkClicked(link)"
          [ngClass]="['nav-item', 'nav-' + link.name.replaceAll(' ', '-').toLowerCase()]"
        >
          <ng-container
            [ngTemplateOutlet]="linkTemplate"
            [ngTemplateOutletContext]="{ $implicit: link, isParent: link?.isParent }"
          ></ng-container>

          <div class="sub-menu {{ link.isActive ? 'active' : '' }}" (mouseleave)="link.isActive = false">
            <ul class="sub-menu-items" *ngIf="link?.children">
              <li
                *ngFor="let sublink of link?.children"
                (click)="onHeaderLinkClicked(sublink)"
                [ngClass]="['nav-item', 'nav-' + sublink.name.replaceAll(' ', '-').toLowerCase()]"
              >
                <ng-container
                  [ngTemplateOutlet]="linkTemplate"
                  [ngTemplateOutletContext]="{ $implicit: sublink, class: 'nav-link-child', isChild: true }"
                ></ng-container>
              </li>
            </ul>
          </div>
        </li>
        <li class="search-item">
          <div #searchItem id="search-component">
            <ush-search-movie [mode]="'desktop'" [classStyle]="'search-header'"></ush-search-movie>
          </div>
        </li>
        <li>
          <ng-container *ngIf="hasLogin">
            <ng-container [ngTemplateOutlet]="loginButton"></ng-container>
          </ng-container>
        </li>
        <ng-container *ngIf="hasTranslationHeader">
          <li>
            <div class="language-select-wrapper">
              <ush-language-selector></ush-language-selector>
            </div>
          </li>
        </ng-container>
        <ng-container *ngIf="headerCustomLinkTemplate">
          <ng-container [ngTemplateOutlet]="headerCustomLinkTemplate"></ng-container>
        </ng-container>
      </ul>
    </div>

    <ng-content select="[extraHeaderElements]"></ng-content>

    <div *ngIf="hasSocialLinks" class="nav-socialLinks">
      <ush-social-links *ngIf="socialLinks?.length > 0" [socialNetworks]="socialLinks"></ush-social-links>
    </div>
  </div>

  <!-- //////////////// HEADER SM ////////////////// -->
  <ng-container *ngIf="!brandedPageLinks.length; else brandedPageHeaderSmall">
    <div id="header-sm" [class.noCollapsed]="isCollapse" class="page-content">
      <ng-container *ngTemplateOutlet="logo"></ng-container>
      <div class="header-items" [class.collapsed]="isCollapse">
        <!-- SEARCH IN TOP -->
        <ng-container *ngIf="headerSMsearchTop">
          <!-- <ush-search-movie [mode]="'mobile'" (movieSelected)="toggleNavbar(null)"></ush-search-movie> -->
        </ng-container>
        <ng-container *ngIf="hasTranslationHeader && !hasCollapsedTranslation">
          <!-- <ush-language-selector></ush-language-selector> -->
        </ng-container>
        <ng-container *ngIf="hasLogin">
          <ng-container [ngTemplateOutlet]="loginButton"></ng-container>
        </ng-container>
        <button
          (click)="toggleNavbar()"
          type="button"
          class="navbar-toggler"
          [ngClass]="!isCollapse ? 'navbar-toggler-bars' : 'navbar-toggler-times'"
        >
          <fa-icon [icon]="toggleIcon" class="navbar-toggler-icon"></fa-icon>
        </button>
      </div>

      <div class="header-collapse-items" [class.collapsed]="isCollapse">
        <ul>
          <ng-content select="[extraHeaderMobileElements]"></ng-content>
          <!-- SEARCH IN COLLAPSE MENU -->
          <li *ngIf="headerSMsearchCollapse" class="search-collapse">
            <ush-search-movie [mode]="'mobile'" (itemSelect)="toggleNavbar(null)"></ush-search-movie>
          </li>
          <li *ngIf="hasSocialLinks" class="nav-socialLinks">
            <ush-social-links *ngIf="socialLinks?.length > 0" [socialNetworks]="socialLinks"></ush-social-links>
          </li>
          <ng-container *ngFor="let link of links" (click)="onHeaderLinkClicked(link)">
            <li
              [ngClass]="['nav-item', 'nav-' + link.name.replaceAll(' ', '-').toLowerCase()]"
              [class.isParentItem]="link?.isParent"
            >
              <ng-container
                [ngTemplateOutlet]="linkTemplate"
                [ngTemplateOutletContext]="{ $implicit: link, isParent: link?.isParent }"
              ></ng-container>
            </li>

            <li
              *ngFor="let sublink of link?.children"
              (click)="onHeaderLinkClicked(sublink)"
              [ngClass]="[
                'nav-item',
                'nav-' + link.name.replaceAll(' ', '-').toLowerCase(),
                'nav-child',
                ' nav-child-' + link.name.replaceAll(' ', '-').toLowerCase()
              ]"
            >
              <ng-container
                [ngTemplateOutlet]="linkTemplate"
                [ngTemplateOutletContext]="{ $implicit: sublink }"
              ></ng-container>
            </li>
          </ng-container>
          <!-- Collapsed menu translation widget -->
          <ng-container *ngIf="hasCollapsedTranslation">
            <!-- <ush-language-selector></ush-language-selector> -->
          </ng-container>
          <!-- header custom links mobile menu -->
          <ng-container *ngIf="headerCustomLinkTemplate">
            <ng-container
              [ngTemplateOutlet]="headerCustomLinkTemplate"
              [ngTemplateOutletContext]="{ $implicit: headerInstance }"
            ></ng-container>
          </ng-container>
        </ul>
      </div>
    </div>
  </ng-container>

  <!-- HEADER TOP SPAN -->
  <div class="header-span"></div>
</div>

<ng-template #brandedPageHeaderSmall>
  <div
    id="header-sm"
    [class.noCollapsed]="isCollapse"
    [class.header-sm-movie]="onMovieMenu"
    class="header-sm-branded-page"
  >
    <ng-container *ngTemplateOutlet="logo"></ng-container>
    <div class="header-items">
      <!-- SEARCH IN TOP -->
      <ng-container *ngIf="headerSMsearchTop">
        <!-- <ush-search-movie [mode]="'mobile'"></ush-search-movie> -->
      </ng-container>
      <ng-container *ngIf="hasTranslationHeader">
        <!-- <ush-language-selector></ush-language-selector> -->
      </ng-container>

      <ng-container *ngIf="hasLogin">
        <ng-container [ngTemplateOutlet]="loginButton"></ng-container>
      </ng-container>
      <button (click)="toggleNavbar()" type="button" class="navbar-toggler">
        <fa-icon [icon]="toggleIcon" class="navbar-toggler-icon"></fa-icon>
      </button>
    </div>

    <div class="header-collapse-items" [class.collapsed]="isCollapse && !onMovieMenu">
      <ul>
        <li *ngIf="hasSocialLinks" class="nav-socialLinks">
          <ush-social-links *ngIf="socialLinks.length > 0" [socialNetworks]="socialLinks"></ush-social-links>
        </li>
        <ng-container *ngFor="let link of links" (click)="onHeaderLinkClicked(link)">
          <li
            [ngClass]="['nav-item', 'nav-' + link.name.replaceAll(' ', '-').toLowerCase()]"
            [class.isParentItem]="link?.isParent"
          >
            <ng-container
              [ngTemplateOutlet]="linkTemplate"
              [ngTemplateOutletContext]="{ $implicit: link }"
            ></ng-container>
          </li>

          <li
            *ngFor="let sublink of link?.children"
            (click)="onHeaderLinkClicked(sublink)"
            [ngClass]="[
              'nav-item',
              'nav-' + link.name.replaceAll(' ', '-').toLowerCase(),
              'nav-child',
              'nav-child-' + link.name.replaceAll(' ', '-').toLowerCase()
            ]"
          >
            <ng-container
              [ngTemplateOutlet]="linkTemplate"
              [ngTemplateOutletContext]="{ $implicit: sublink }"
            ></ng-container>
          </li>
        </ng-container>

        <!-- branded menu toggler -->
        <li class="nav-item" (click)="onMovieMenu = true">
          <a class="menu-toggler" [attr.data-translate]="'public.header.menu-toggler'">{{
            'public.header.menu-toggler' | translate: { params: { movie: brandedMovie?.title } }
          }}</a>
        </li>

        <!-- SEARCH IN COLLAPSE MENU -->
        <li *ngIf="headerSMsearchCollapse" class="search-collapse">
          <!-- <ush-search-movie [mode]="'desktop'"></ush-search-movie> -->
        </li>
      </ul>
    </div>
    <!-- branded movie menu -->
    <div class="header-collapse-items header-movie-menu" [class.collapsed]="isCollapse && onMovieMenu">
      <ul>
        <li
          *ngFor="let link of brandedPageLinks"
          [ngClass]="{ active: link.isActive }"
          class="nav-item menu-{{ link.name | kebabCase }}"
        >
          <ng-container *ngIf="!link?.isExternal">
            <a *ngIf="link?.label" (click)="gotoSection(link)">
              <span [attr.data-translate]="link.label">{{
                link.label | translate: { placeholder: link.label }
              }}</span></a
            >
            <a *ngIf="!link?.label" (click)="gotoSection(link)">
              <span [attr.data-translate]="'movie-template-a.menu.' + (link.name | cammelCase)">
                {{ 'movie-template-a.menu.' + (link.name | cammelCase) | translate: { placeholder: link.name } }}
              </span>
            </a>
          </ng-container>
          <ng-container *ngIf="link?.isExternal">
            <a *ngIf="link?.label" [href]="link.link" target="_blank">
              <span [attr.data-translate]="link.label">
                {{ link.label | translate }}
              </span>
            </a>
            <a *ngIf="!link?.label" [href]="link.link" target="_blank">
              <span [attr.data-translate]="'movie-template-a.menu.' + (link.name | cammelCase)">
                {{ 'movie-template-a.menu.' + (link.name | cammelCase) | translate }}
              </span>
            </a>
          </ng-container>
        </li>

        <li class="nav-item menu-toggler-list-item" (click)="onMovieMenu = false">
          <a class="menu-toggler" [attr.data-translate]="'public.header.menu-toggler-branded'">{{
            'public.header.menu-toggler-branded' | translate: { params: { movie: brandedMovie?.trTitle } }
          }}</a>
        </li>
        <li class="menu-social-links-list-item">
          <ush-social-links [socialNetworks]="brandedMovie?.socialNetworks" [movie]="brandedMovie"></ush-social-links>
        </li>
        <ng-container *ngIf="hasTranslationHeader">
          <!-- <ush-language-selector></ush-language-selector> -->
        </ng-container>
      </ul>
    </div>
  </div>
</ng-template>

<ng-template #logo let-class="class">
  <!-- supporting optional logo link coming form environment file -->
  <a
    class="nav-logo nav-link"
    (click)="onHeaderLogoClicked()"
    [ngClass]="class"
    *ngIf="!logoLinkExternal"
    [routerLink]="logoLink"
    [fragment]="logoFragment"
    (click)="onGoHome()"
  >
    <img id="logo" [src]="logoUrl | img: logoParams" alt="logo" />
  </a>
  <a class="nav-logo nav-link" [ngClass]="class" *ngIf="logoLinkExternal" [href]="logoLink" target="_blank">
    <img id="logo" [src]="logoUrl | img: logoParams" alt="logo" />
  </a>
  <!-- end supporting optional logo block -->
</ng-template>

<ng-template #linkTemplate let-link let-class="class" let-isParent="isParent" let-isChild="isChild">
  <a
    *ngIf="!link?.isExternal"
    [attr.data-external]="link?.isExternal || false"
    [routerLink]="(!link?.isParent && !link?.isPopup && !link?.isExternal ? link.link : null) | normalizeRoute"
    [queryParams]="link?.params"
    [fragment]="link?.fragment"
    [ngClass]="{ active: link.isActive, hasLink: link?.link, isParent: isParent, isChild: isChild }"
    class="nav-link bold"
    (click)="onLinkClick(link)"
    [attr.data-translate]="'public.header.link.channel.' + (link.name | cammelCase)"
  >
    <span>
      {{
        'public.header.link.channel.' + (link.name | cammelCase)
          | translate: { placeholder: link.name, params: { letter: 'firstletter' } }
      }}
    </span>

    <i class="pi pi-chevron-down" *ngIf="isParent"></i>
  </a>
  <a
    *ngIf="link?.isExternal"
    [attr.data-external]="link?.isExternal || false"
    [href]="link?.isExternal ? link.link : null"
    target="_blank"
    class="nav-link bold"
    [ngClass]="{ hasLink: link?.link, isParent: isParent, isChild: isChild }"
    (click)="onLinkClick(link)"
    [attr.data-translate]="'public.header.link.channel.' + (link.name | cammelCase)"
  >
    <span>
      {{ 'public.header.link.channel.' + (link.name | cammelCase) | translate: { placeholder: link.name } }}
    </span>
  </a>
</ng-template>

<ng-template #loginButton>
  @if (isCommunityFeaturesEnabled) {
    <ush-user-dropdown-community></ush-user-dropdown-community>
  } @else {
    <ush-user-dropdown></ush-user-dropdown>
  }
</ng-template>
